// components/MobileHeader.tsx
import { motion } from 'framer-motion';
import { auth } from '../firebaseConfig';
import { FaSignOutAlt } from 'react-icons/fa';
import { AppView } from '../hooks/useAppNavigation';

const IconSignOut = FaSignOutAlt as any;

interface MobileHeaderProps {
  currentView?: AppView;
  specialTitle?: string; // Special title from HeroSection (only shown in hero view)
}

export const MobileHeader = ({ currentView, specialTitle }: MobileHeaderProps) => {
  const handleLogout = () => {
    auth.signOut();
  };

  // Cambiar estilo según la vista actual
  const isSpotifyView = currentView === 'spotify';

  // Get default greeting if no special title yet
  const getDefaultGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "¡Buenos días, hermosa!";
    if (hour < 19) return "¡Buenas tardes, linda!";
    return "¡Buenas noches, mi vida!";
  };

  // Títulos para cada vista
  const viewTitles = {
    hero: specialTitle || getDefaultGreeting(), // Use special title or greeting, never 'Betty'
    canvas: 'Canvas',
    calendario: 'Notes',
    maps: 'Lugares',
    spotify: 'Música'
  };

  return (
    <motion.header 
      initial={{ y: -50 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isSpotifyView 
          ? 'bg-black/90 border-b border-green-400/30' 
          : 'bg-white/20 backdrop-blur-lg border-b border-white/20'
      }`}
    >
      <div className="flex justify-between items-center p-4 pt-safe-area-inset-top">
        <motion.h1 
          key={currentView} // Re-animar cuando cambie la vista
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className={`font-script text-2xl transition-colors duration-300 ${
            isSpotifyView ? 'text-green-400' : 'text-secondary'
          }`}
        >
          {currentView ? viewTitles[currentView] : 'Betty'}
        </motion.h1>
        
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={handleLogout}
          className={`flex items-center justify-center w-10 h-10 rounded-full shadow-md transition-all duration-300 ${
            isSpotifyView 
              ? 'bg-green-400/20 hover:bg-green-400/30 text-green-400 border border-green-400/50' 
              : 'bg-white/60 hover:bg-white text-primary'
          }`}
        >
          <IconSignOut />
        </motion.button>
      </div>
    </motion.header>
  );
};